export default {
  methods: {
    onScroll(direction, power = 1) {
      if (this.isScrolling) {
        return true;
      }

      if(document.querySelectorAll('.overlay').length){
        return true;
      }

      if (direction === 'down' && this.isScrollTop === true) {
        this.isScrollTop = false;
        this.isScrolling = true;
        setTimeout(() => {this.isScrolling = false;}, 500);
      }

      if (direction === 'up' && this.isAllTop() && this.isScrollTop !== true) {
        this.scrollingTopScore += power;
        setTimeout(() => {this.scrollingTopScore -= power;}, 1000);

        if (this.scrollingTopScore > 490) {
          this.isScrollTop = true;
          this.isScrolling = true;
          setTimeout(() => {this.isScrolling = false;}, 500);
        }

      }
    },
    isAllTop() {
      // if (window.pageYOffset) {
      //   return false;
      // }

      for (let i = 0; i < this.scrollSelectors.length; i++) {

        if (document.querySelector(this.scrollSelectors[i]) &&
          document.querySelector(this.scrollSelectors[i]).scrollTop !== 0) {
          return false;
        }
      }
      return true;
    },
    initScrollInfo(selectors) {
      this.scrollSelectors = selectors;

      for (let i = 0; i < this.scrollSelectors.length; i++) {
        if(document.querySelector(this.scrollSelectors[i])) {
          document.querySelector(this.scrollSelectors[i]).onscroll = () => {
            if (document.querySelector(this.scrollSelectors[i]).scrollTop) {
              this.onScroll('down');
            }
            // else {
            //   // this.onScroll('up');
            // }
          };
        }
      }

      // window.addEventListener('scroll', function(e) {
      //   if (this.scrollY) {
      //     this.onScroll('down');
      //   }
      // });

      document.addEventListener('wheel', (e) => {
        if (e.deltaY > 0) {
          this.onScroll('down');
        }
        else if (e.deltaY < 0) {

          this.onScroll('up', Math.abs(e.deltaY));
        }
      });

    },
  },
  data() {
    return {
      isScrolling: false,
      scrollSelectors: [],
      isScrollTop: true,
      scrollingTopScore: 0,
    };
  },
};
